<stc-apps-loader></stc-apps-loader>
<div class="main-layout" [class.sidebar-closed]="!isSidebarVisible">
  <div class="left-side">
    <stc-apps-navigation-sidebar
      [sidebarLinks]="navItems"
      [username]="username"
      [userRole]="userRole"
      [isSidebarExpanded]="isSidebarVisible"
      (toggleMenu)="toggleSidebar($event)"
      (logout)="logout()"
    />

    <!-- <stc-apps-sidebar
      [logoSrc]="logoSrc"
      [sidebarLinks]="navItems"
      [isAdmin]="isAllowed"
      (logoutFun)="onLogout()"
      [secondLogoSrc]="'assets/images/qeema-logo.svg'"
      [justifyContent]="'flex-start'"
    /> -->
  </div>
  <div class="right-side" [class.api-test-url]="isApiTestUrl">
    <div class="main-layout_container">
      <router-outlet></router-outlet>
    </div>
  </div>
</div>
<!-- <div class="main-layout">
  <div
    class="main-layout_hamburger-menu"
    (click)="toggleSidebar()"
    [ngClass]="{ 'sidebar-open': isSidebarVisible }"
    [ngStyle]="{
      color: isSidebarVisible ? 'var(--whiteColor)' : 'var(--stc-color)'
    }"
  >
    <i class="pi pi-bars"></i>
  </div>

  <div class="main-layout_sidebar" [ngClass]="{ hidden: !isSidebarVisible }">
    <stc-apps-sidebar
      [logoSrc]="logoSrc"
      [sidebarLinks]="navItems"
      [isAdmin]="isAllowed"
      (logoutFun)="onLogout()"
      [secondLogoSrc]="'assets/images/qeema-logo.svg'"
      [justifyContent]="'flex-start'"
      [routerLinkActiveOptions]="{ exact: false }"
    />
    <stc-apps-navigation-sidebar />
  </div>

  <div class="main-layout_header">
    <div class="main-layout_container">
      <router-outlet></router-outlet>
    </div>
  </div>
</div> -->
